import { emotionTheme } from '@styles/theme'
import { CheckCircleIcon, XCircleIcon } from '@phosphor-icons/react'

import type { ProfileStatusProps } from './types'

import * as S from './styles'

export const ProfileStatus = ({ status }: ProfileStatusProps) => {
  const statusMap = {
    active: {
      icon: <CheckCircleIcon size={18} />,
      label: 'Ativo',
      color: emotionTheme.colors.green[500],
      background: emotionTheme.colors.green[100]
    },
    inactive: {
      icon: <XCircleIcon size={18} />,
      label: 'Inativo',
      color: emotionTheme.colors.gray.dark,
      background: emotionTheme.colors.gray[200]
    }
  }

  return (
    <S.Container>
      <S.Content
        style={{
          color: statusMap[status].color,
          background: statusMap[status].background
        }}
      >
        {statusMap[status].label}
        {statusMap[status].icon}
      </S.Content>
    </S.Container>
  )
}
